webpackJsonp([189221045269989],{

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookRouter = __webpack_require__(64);
	
	var _LoreHookRouter2 = _interopRequireDefault(_LoreHookRouter);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookRouter2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'lore-hook-router'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Source code for this hook can be found on GitHub ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/packages/lore-hook-router' },
	        'at this link'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Purpose'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'A hook for generating the routes for React Router and specifying the type of history that should be used (hash or browser). The actual inclusion of React Router is handled by ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-hook-react'
	      ),
	      ' since the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Router'
	      ),
	      ' needs to wrap the application, and that\'s part of the mounting process.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Config'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      /**\n       * This file is where you define overrides for the default routing behavior.\n       **/\n\n      import { browserHistory, useRouterHistory } from \'react-router\';\n      import { createHistory } from \'history\';\n\n      export default {\n\n        /**\n         * Whether browser should use pushState or hash to keep track of routes\n         * See: https://github.com/ReactTraining/react-router/blob/v3.2.0/docs/guides/Histories.md\n         **/\n\n        // history: browserHistory,\n\n        /*\n         * The default setting for the routing history, as defined in lore-hook-router,\n         * is "browserHistory", which is shown above. But this configuration assumes your\n         * application will be served from a root domain, such as https://app.mycompany.com.\n         *\n         * If your application needs to be served from behind a proxy URL instead, such as\n         * https://www.mycompany.com/application/, then you need to do some extra steps when\n         * configuring webpack and react-router so that you get the correct URLS for the\n         * generated assets and so that actions like page refresh work like you expect.\n         *\n         * To make that process easier, this file has modified the default. The code below\n         * generates identical behavior to \'browserHistory\' except that it also allows you to\n         * specify a \'basename\' so that you can serve the application from a URL like /application/\n         * instead of being restricted to the root domain.\n         *\n         * To coordinate the change with webpack, basename is provided as __BASENAME__, which\n         * will be defined by webpack during build, and replaced with a real value. This will\n         * be an empty string if the app will be served from the root domain, or something like\n         * \'/application\' if the app will be served from /application/.\n         */\n\n        history: useRouterHistory(createHistory)({\n          basename: __BASENAME__\n        }),\n\n        /**\n         * Returns the routes used by the application.\n         *\n         * The \'lore.loader\' object is a way of lazy-loading files and directories the framework\n         * doesn\'t have control over such as the models, config directory, and in this case the\n         * routes.js file at the root of the project.\n         *\n         * The reason the loader is used here is because the routes _must_ to be lazy-loaded,\n         * since loading the routes will pull in the components, which may be using the\n         * \'lore.connect\' decorator that won\'t exist until the \'connect\' hooks loads.\n         *\n         * Trying to load the routes directly in this config file will throw an error during\n         * build, because lore loads the config file _before_ any of the hooks, since they\n         * need information in the config to determine their behavior.\n         */\n\n        // routes: function(lore) {\n        //   return lore.loader.loadRoutes();\n        // }\n\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-router-index-js-b174e77dd9721957ba67.js